import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';

import PageNumber from './PageNumber';
import chevronRight from '../../img/chev-r.svg';
import chevronLeft from '../../img/chev-l.svg';
import CategoryIndex from '../../templates/category_index';

const PaginationLinksStyle = styled.div`
    {
        span {
            width: 29px;
            height: 29px;
        }

        a {
            margin: 5px;
            // width: 9px;
            font-family: Helvetica Neue;
            font-size: 19px;
            font-weight: 500;
            padding: 5px;
            color: #818181;
            text-decoration: underline;
        }
        .noMore {
            visibility: hidden;
        }
    }
`

class PaginationLinks extends React.Component {
    render(){
        const {numberOfPages, humanPageNumber, firstPageInRange, lastPageInRange, lastMultOf5} = this.props
        const pageLinkMax = numberOfPages < 5 ? numberOfPages : 5
        const pagesLeft = numberOfPages - humanPageNumber


        const pages = []
        if (pagesLeft <= 5  && humanPageNumber >= pageLinkMax) {
           if (CategoryIndex.isCurrentPageNumberInRange(humanPageNumber, firstPageInRange, lastPageInRange)){
            for (let i= firstPageInRange; i <= lastPageInRange; i++){
                pages.push(<PageNumber number={i} key={i} {...this.props} />)
            }
           } else {
               for (let i= lastPageInRange +1; i <= numberOfPages; i++){
                   pages.push(<PageNumber number={i} key={i} {...this.props} />)
               }
           }

        }
        else {
            for (let i= firstPageInRange; i <= lastPageInRange; i++){
                pages.push(<PageNumber number={i} key={i} {...this.props} />)
            }
        }


        return (
        <PaginationLinksStyle>
           <span>
                {this.props.previousPagePath ? (
                    <Link to={`${this.props.previousPagePath}` }>
                         <img src={chevronLeft} alt=""/>
                  </Link>
                ) : (<Link className="noMore" to={`${this.props.category}/`}>
                <img src={chevronLeft} alt=""/>
                    </Link> )
                }
                {pages}
                {/* {console.log("nextpagepath", this.props)} */}
                {/* {console.log("prevpagepath", this.props.prevPagePath)} */}
                {this.props.nextPagePath ? (
                    <Link to={this.props.nextPagePath}>
                         <img src={chevronRight} alt=""/>
                  </Link>
                ) : (<Link className="noMore" to={`${this.props.category}/${this.props.numberOfPages}`}>
                <img  src={chevronRight} alt=""/>
         </Link> )
                }
            </span>
        </PaginationLinksStyle>
       )
    }
}


export default PaginationLinks
